import React, { useEffect, useState } from "react";
import api from "../../../../api/axios";

export default function OrganizationSelect({
    value = "",
    onChange,
    className = "",
    includeAll = true,
    allLabel = "All Organizations",
}) {
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        loadOrganizations();
    }, []);

    const loadOrganizations = async () => {
        try {
            setLoading(true);

            const response = await api.get("/user/list?role=organization");

            if (response?.data?.success) {
                setOrganizations(response.data.data.list || []);
            } else {
                setOrganizations([]);
            }
        } catch (err) {
            console.log(err?.response?.data?.message || err.message);
            setOrganizations([]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <select
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            disabled={loading}
            className={`rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none ${className}`}
        >
            {includeAll && <option value="">{allLabel}</option>}

            {organizations.map((org) => (
                <option key={org.org_id} value={org.org_id}>
                    {org.org_name || org.user_name || org.email}
                </option>
            ))}
        </select>
    );
}